import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import StoryField from "./story_field"
import RelatedContent from "./related_content"
import "./story.scss"
import { fullStoryShape } from "app/lib/shared_prop_types"
import { sliceModulo } from "shared/lib/utils"

export default class IFTTTNextStory extends Component {
  render() {
    const {
      story: { discoverable, fields, related_content },
      linkAppletCardsToConsumerSite,
    } = this.props

    return (
      <>
        <div
          className="story-content"
          styleName={classnames({
            // so that main css can redefine the main story container's width
            "story-content": true,
            "non-discoverable-content": discoverable === true,
          })}
        >
          <ul styleName="story-fields">
            {fields.map((field, idx) => (
              <StoryField
                key={idx}
                fieldPosition={idx}
                field={field}
                linkAppletCardsToConsumerSite={linkAppletCardsToConsumerSite}
              />
            ))}
          </ul>
          {related_content?.length > 0 && (
            <div styleName="related-content-container">
              <RelatedContent relatedContent={sliceModulo(related_content, 3)} onStoryPage />
            </div>
          )}
        </div>
      </>
    )
  }
}

IFTTTNextStory.propTypes = {
  story: fullStoryShape.isRequired,
  linkAppletCardsToConsumerSite: PropTypes.bool,
}

IFTTTNextStory.defaultProps = {
  linkAppletCardsToConsumerSite: false,
}
